// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8b4a6b4a","703":"eaf011b5","787":"229450fc"}[chunkId] + ".chunk.js";
};